// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chance_chancePage__5s0oY {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}
.Chance_share__dX0hf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  max-width: 500px;
  padding: 0 16px;
  padding-top: 24px;
}
.Chance_title__gm2\\+b {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.Chance_titleInner__vnPiH {
  width: 100%;
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 24px;
  gap: 2px;
  padding: 4px 8px;
  margin-bottom: 16px;
  color: #fff;
}
.Chance_titleDesc__-tgYT {
  color: #f7ff65;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.Chance_text-items__k-sqU {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;
}
.Chance_rule__IfHLr {
  border-radius: 16px;
  background: #507687;
  color: #fcfaee;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  margin-bottom: 24px;
}
.Chance_rule-icon__C5H25 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
}

.Chance_information__fpTyy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  min-height: 112px;
}
.Chance_information-inner__lKHuL {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  width: 100%;
  margin-bottom: 16px;
  position: relative;
}
.Chance_share-box__sH8sC {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.Chance_share-box__sH8sC span {
  font-size: 16px !important;
}
.Chance_share-box__sH8sC img {
  width: 20px;
  height: 20px;
}
.Chance_information-title__NSD8L {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  padding: 16px 0px;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
}
.Chance_information-title__NSD8L span {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}
.Chance_information-items__Rwqyv {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 16px;
  padding-top: 20px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}
.Chance_information-item__bjhJV {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  position: relative;
}
.Chance_information-item-number__pd8\\+7 {
  color: #f7ff65;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
}
.Chance_information-item-arrow__VOCm3 {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 18px;
}
.Chance_information-item-leter__-fwY5 {
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px;
}
.Chance_information-line__81Gb\\+ {
  width: 1px;
  background: rgba(252, 252, 237, 0.2);
  height: 24px;
}

.Chance_move-tobanibon__cJUV2 {
  height: 44px;
  padding: 10px;
  border: 1px solid #ff392d;
}
.Chance_move-tobanibon__cJUV2 span {
  font-size: 16px;
}
.Chance_expire-state__hp5Yd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: #015551;
  backdrop-filter: blur(8px);
  color: #fff;
  margin-bottom: 24px;
}
.Chance_expire-title__VSW7e {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}
.Chance_informationAll__UJgmO {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-feature-settings: "ss01" on;
  gap: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 36px;
  height: 45px;
}
.Chance_informationAll__UJgmO p {
}
.Chance_informationAll__UJgmO div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
}
.Chance_informationAll__UJgmO div span:nth-child(1) {
  color: #f7ff65;
}
.Chance_informationAll__UJgmO div span:nth-child(2) {
}

.Chance_required-chance-text-container__k79Ie {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.Chance_game-chance-card-container__Rgyxc {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 16px;
}

.Chance_chance-daily-text-container__aRhYv {
  width: 100%;
  background: #507687;
  padding: 12px 16px;
  border-radius: 16px;
  color: #fcfaee;
  font-size: 12px;
  font-weight: 300;
  text-align: "center";
  margin-top: 16px;
}

.Chance_invite-friends-list-container__YjPGE {
  list-style-type: disc;
  width: 100%;
  overflow: hidden;
  padding-right: 24px;
  padding-left: 24px;
  color: #fcfaee;
  font-size: 14px;
  font-weight: 400;
  margin-top: 16px;
}

.Chance_line__MYh2e {
  background: rgba(250, 247, 228, 0.24);
  width: 25px;
  height: 1px;
}

@media screen and (min-width: 1200px) {
  .Chance_title__gm2\\+b {
    font-size: 16px;
  }
  .Chance_rule__IfHLr {
    font-size: 13px;
  }
  .Chance_information-title__NSD8L span {
    font-size: 14px;
  }
  .Chance_informationAll__UJgmO {
    font-size: 14px;
  }
  .Chance_informationAll__UJgmO div span:nth-child(1) {
    font-size: 16px;
  }
  .Chance_line__MYh2e {
    background: rgba(250, 247, 228, 0.24);
    width: 55px;
    height: 1px;
  }
  .Chance_share__dX0hf {
    padding-top: 48px;
  }
  .Chance_chance-daily-text-container__aRhYv {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/chance/Chance.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC;;;;0CAIwC;EACxC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;AACA;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;IACrC,WAAW;IACX,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".chancePage {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n.share {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  opacity: 0;\n  visibility: hidden;\n  max-width: 500px;\n  padding: 0 16px;\n  padding-top: 24px;\n}\n.title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.titleInner {\n  width: 100%;\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  align-self: stretch;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 24px;\n  gap: 2px;\n  padding: 4px 8px;\n  margin-bottom: 16px;\n  color: #fff;\n}\n.titleDesc {\n  color: #f7ff65;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.text-items {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 24px;\n}\n.rule {\n  border-radius: 16px;\n  background: #507687;\n  color: #fcfaee;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  margin-bottom: 24px;\n}\n.rule-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20%;\n}\n\n.information {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 16px;\n  min-height: 112px;\n}\n.information-inner {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.12);\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  width: 100%;\n  margin-bottom: 16px;\n  position: relative;\n}\n.share-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.share-box span {\n  font-size: 16px !important;\n}\n.share-box img {\n  width: 20px;\n  height: 20px;\n}\n.information-title {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  padding: 16px 0px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n}\n.information-title span {\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}\n.information-items {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  align-items: center;\n  padding-bottom: 16px;\n  padding-top: 20px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n}\n.information-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  position: relative;\n}\n.information-item-number {\n  color: #f7ff65;\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n}\n.information-item-arrow {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  left: 18px;\n}\n.information-item-leter {\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 36px;\n}\n.information-line {\n  width: 1px;\n  background: rgba(252, 252, 237, 0.2);\n  height: 24px;\n}\n\n.move-tobanibon {\n  height: 44px;\n  padding: 10px;\n  border: 1px solid #ff392d;\n}\n.move-tobanibon span {\n  font-size: 16px;\n}\n.expire-state {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: #015551;\n  backdrop-filter: blur(8px);\n  color: #fff;\n  margin-bottom: 24px;\n}\n.expire-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n.informationAll {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  text-align: center;\n  font-feature-settings: \"ss01\" on;\n  gap: 4px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 36px;\n  height: 45px;\n}\n.informationAll p {\n}\n.informationAll div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n}\n.informationAll div span:nth-child(1) {\n  color: #f7ff65;\n}\n.informationAll div span:nth-child(2) {\n}\n\n.required-chance-text-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.game-chance-card-container {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.chance-daily-text-container {\n  width: 100%;\n  background: #507687;\n  padding: 12px 16px;\n  border-radius: 16px;\n  color: #fcfaee;\n  font-size: 12px;\n  font-weight: 300;\n  text-align: \"center\";\n  margin-top: 16px;\n}\n\n.invite-friends-list-container {\n  list-style-type: disc;\n  width: 100%;\n  overflow: hidden;\n  padding-right: 24px;\n  padding-left: 24px;\n  color: #fcfaee;\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 16px;\n}\n\n.line {\n  background: rgba(250, 247, 228, 0.24);\n  width: 25px;\n  height: 1px;\n}\n\n@media screen and (min-width: 1200px) {\n  .title {\n    font-size: 16px;\n  }\n  .rule {\n    font-size: 13px;\n  }\n  .information-title span {\n    font-size: 14px;\n  }\n  .informationAll {\n    font-size: 14px;\n  }\n  .informationAll div span:nth-child(1) {\n    font-size: 16px;\n  }\n  .line {\n    background: rgba(250, 247, 228, 0.24);\n    width: 55px;\n    height: 1px;\n  }\n  .share {\n    padding-top: 48px;\n  }\n  .chance-daily-text-container {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chancePage": `Chance_chancePage__5s0oY`,
	"share": `Chance_share__dX0hf`,
	"title": `Chance_title__gm2+b`,
	"titleInner": `Chance_titleInner__vnPiH`,
	"titleDesc": `Chance_titleDesc__-tgYT`,
	"text-items": `Chance_text-items__k-sqU`,
	"rule": `Chance_rule__IfHLr`,
	"rule-icon": `Chance_rule-icon__C5H25`,
	"information": `Chance_information__fpTyy`,
	"information-inner": `Chance_information-inner__lKHuL`,
	"share-box": `Chance_share-box__sH8sC`,
	"information-title": `Chance_information-title__NSD8L`,
	"information-items": `Chance_information-items__Rwqyv`,
	"information-item": `Chance_information-item__bjhJV`,
	"information-item-number": `Chance_information-item-number__pd8+7`,
	"information-item-arrow": `Chance_information-item-arrow__VOCm3`,
	"information-item-leter": `Chance_information-item-leter__-fwY5`,
	"information-line": `Chance_information-line__81Gb+`,
	"move-tobanibon": `Chance_move-tobanibon__cJUV2`,
	"expire-state": `Chance_expire-state__hp5Yd`,
	"expire-title": `Chance_expire-title__VSW7e`,
	"informationAll": `Chance_informationAll__UJgmO`,
	"required-chance-text-container": `Chance_required-chance-text-container__k79Ie`,
	"game-chance-card-container": `Chance_game-chance-card-container__Rgyxc`,
	"chance-daily-text-container": `Chance_chance-daily-text-container__aRhYv`,
	"invite-friends-list-container": `Chance_invite-friends-list-container__YjPGE`,
	"line": `Chance_line__MYh2e`
};
export default ___CSS_LOADER_EXPORT___;
